import * as React from "react";
import { useImperativeHandle, useState } from "react";
import styled from "styled-components";
import { Input } from "components/bootstrap";
export const Container = styled.div`
  width: 100%;
`;
const TypeAheadInput = ({
  id,
  label,
  formGroupClassName = void 0,
  buttonAfter = void 0,
  onChange = void 0,
  onKeyDown = void 0,
  placeholder = void 0
}, ref) => {
  const [value, setValue] = useState("");
  const handleChange = (event) => {
    const nextValue = event.target.value;
    setValue(nextValue);
    onChange == null ? void 0 : onChange(nextValue);
  };
  useImperativeHandle(
    ref,
    () => ({
      getValue: () => value,
      clear: () => setValue("")
    }),
    [value, setValue]
  );
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id,
      type: "text",
      wrapperClassName: "typeahead-wrapper",
      formGroupClassName,
      label,
      value,
      buttonAfter,
      placeholder,
      onKeyDown,
      onChange: handleChange
    }
  ));
};
export default React.forwardRef(TypeAheadInput);
